import { render, staticRenderFns } from "./BlackHoleViz.vue?vue&type=template&id=cc7b126e&scoped=true"
import script from "./BlackHoleViz.vue?vue&type=script&lang=js"
export * from "./BlackHoleViz.vue?vue&type=script&lang=js"
import style0 from "./BlackHoleViz.vue?vue&type=style&index=0&id=cc7b126e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7b126e",
  null
  
)

export default component.exports